import { adminUrlBuilder } from '@app/api/utils';
import {
  IBundlePackTemplate,
  ICustomerBundlePack,
  ICustomerBundlePackWithCustomer,
  PaymentMethod
} from '@torim-app/types';

const BASE = 'bundle-packs';

export class BundlePacksApi {
  static async fetchTemplates(): Promise<IBundlePackTemplate[]> {
    const url = adminUrlBuilder({}, `${BASE}/templates`);
    const res = await fetch(url);
    if (!res.ok) throw res.statusText;
    return res.json();
  }

  static async createTemplate(body: Partial<IBundlePackTemplate>): Promise<IBundlePackTemplate> {
    const url = adminUrlBuilder({}, `${BASE}/templates`);
    const res = await fetch(url, {
      method: 'post',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw res.statusText;
    return res.json();
  }

  static async updateTemplate(id: string, body: Partial<IBundlePackTemplate>): Promise<IBundlePackTemplate> {
    const url = adminUrlBuilder({}, `${BASE}/templates/${id}`);
    const res = await fetch(url, {
      method: 'put',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw res.statusText;
    return res.json();
  }

  static async deleteTemplate(id: string): Promise<{ success: boolean }> {
    const url = adminUrlBuilder({}, `${BASE}/templates/${id}`);
    const res = await fetch(url, { method: 'delete' });
    if (!res.ok) throw res.statusText;
    return res.json();
  }

  static async fetchCustomerPacks(customerId: string): Promise<ICustomerBundlePack[]> {
    const url = adminUrlBuilder({}, `${BASE}/customer/${customerId}`);
    const res = await fetch(url);
    if (!res.ok) throw res.statusText;
    return res.json();
  }

  static async fetchAllPacks(): Promise<ICustomerBundlePackWithCustomer[]> {
    const url = adminUrlBuilder({}, `${BASE}/all`);
    const res = await fetch(url);
    if (!res.ok) throw res.statusText;
    return res.json();
  }

  static async assignPack(body: { templateId: string; customerId: string }): Promise<ICustomerBundlePack> {
    const url = adminUrlBuilder({}, `${BASE}/assign`);
    const res = await fetch(url, {
      method: 'post',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw res.statusText;
    return res.json();
  }

  static async sendBundlePackPaymentLink(
    id: string,
    body: { paymentMethod: PaymentMethod; useCustomerBalance?: boolean }
  ): Promise<{ message?: string; phoneNumber?: string }> {
    const url = adminUrlBuilder({}, `${BASE}/assign/${id}/send-payment`);
    const res = await fetch(url, {
      method: 'put',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw res.statusText;
    return res.json();
  }

  static async activateBundlePackNoPayment(id: string): Promise<{ success: boolean }> {
    const url = adminUrlBuilder({}, `${BASE}/assign/${id}/activate-no-payment`);
    const res = await fetch(url, { method: 'put' });
    if (!res.ok) throw res.statusText;
    return res.json();
  }

  static async redeemBundlePack(id: string): Promise<ICustomerBundlePack | null> {
    const url = adminUrlBuilder({}, `${BASE}/assign/${id}/redeem`);
    const res = await fetch(url, {
      method: 'put',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({})
    });
    if (!res.ok) throw res.statusText;
    return res.json();
  }

  static async cancelPack(id: string): Promise<{ success: boolean }> {
    const url = adminUrlBuilder({}, `${BASE}/assign/${id}`);
    const res = await fetch(url, { method: 'delete' });
    if (!res.ok) throw res.statusText;
    return res.json();
  }
}
